// extracted by mini-css-extract-plugin
module.exports = {"button":"Wlovp","block":"hEjIQ","label":"_3WHt9"};